import { useMemo } from 'react';
import { useProjectModel } from '../model.js';
import { ProjectFilesService } from './project-files-service.js';

export const useProjectFilesService = () => {
  const { projectFolder } = useProjectModel();

  return useMemo(() => new ProjectFilesService(projectFolder), [projectFolder]);
};
